module.exports = __webpack_public_path__ + "img/emoji_42.e8151553.png";